<div [id]="'notif-preautorisation-' + id" class="notification-container" [ngClass]="{ animation: loaded }">
  <button class="close-notification-btn" id="btn-fermer" (click)="closeNotification()" appDisabledIfConseiller>
    <img
      src="{{ obtenirUrlAbsolu('assets/images/icone-close.svg') }}"
      alt=""
      [alt]="'btn.fermer-notification' | translate"
    />
  </button>
  <div class="notification-content wrapper" id="contenu-notification">
    <span>{{ 'notifications.changement-section' | translate }}</span>
    <strong>
      <a class="link white-space-no-wrap " (click)="scrollToSection()" id="btn-vers-section" appDisabledIfConseiller>
        {{ 'notifications.preautorisation' | translate }}
      </a>
    </strong>
  </div>
</div>
